var _rect, _rect2, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtmlLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.15,
    height: 30.15,
    transform: "translate(0.149994)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_122)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 26.8,
    height: 26.8,
    transform: "translate(2.16 2.01)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_122",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 27,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.96 2.01H2.16V28.81H28.96V2.01Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.83331 2.01H9.04124V3.20344H10.1462V2.01H11.3542V5.62402H10.1463V4.41384H9.0413V5.62402H7.83336L7.83331 2.01Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9428 3.20846H11.8794V2.01H15.2147V3.20846H14.1508V5.62402H12.9428L12.9428 3.20846Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.744 2.01H17.0036L17.7784 3.27986L18.5523 2.01H19.8124V5.62402H18.6094V3.83271L17.7784 5.11771H17.7576L16.9259 3.83271V5.62402H15.744V2.01Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4136 2.01H21.6219V4.42944H23.3206V5.62402H20.4136V2.01Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79462 26.6575L5.50999 7.27684H25.61L23.3238 26.6545L15.5485 28.81L7.79462 26.6575ZM12.4148 16.0495L12.1976 13.6154H21.2933L21.5061 11.2384H9.5999L10.241 18.4264H18.4787L18.2029 21.5091L15.5518 22.2247L15.5499 22.2255L12.9028 21.5107L12.7335 19.6149H10.3474L10.6804 23.3472L15.5495 24.6988L20.4248 23.347L21.019 16.6878L21.077 16.0495H12.4148Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.8,
    height: 26.8,
    fill: "white",
    transform: "translate(2.16 2.01)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlLogo);
export default __webpack_public_path__ + "static/media/html-logo.313124578e4bc6c8fe24ad6eab002b40.svg";
export { ForwardRef as ReactComponent };